import { Action } from '@ngrx/store';

export enum ContentActionTypes {
  DisableMargin = '[Content] Disable Margin',
  EnableMargin = '[Content] Enable Margin',
}

export class DisableMargin implements Action {
  readonly type = ContentActionTypes.DisableMargin;
}

export class EnableMargin implements Action {
  readonly type = ContentActionTypes.EnableMargin;
}

export type ContentActions = DisableMargin | EnableMargin;
